import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {takeEvery, put, delay, select, getContext, call} from 'typed-redux-saga'
import ReactPTApi from 'src/api/reactpt'
import {RootState} from '../rootReducer'
import {actions as actionTypeActions} from '../modules/actionTypes'
import {actions as bodyAreaActions} from '../modules/bodyAreas'
import {actions as equipmentActions} from '../modules/equipment'
import {actions as activitiesActions} from '../modules/activities'
import {actions as goalActions} from '../modules/goals'

export type AppState = {
  error?: Error
  environmentIndex: number
}
export const initialState: AppState = {environmentIndex: 0}

export const {actions, reducer} = createSlice({
  name: 'app',
  initialState,
  reducers: {
    init: () => {},
    setError: (state: AppState, action: PayloadAction<{error?: Error}>) => {
      const {error} = action.payload
      return {...state, error}
    },
    showError: (_state: AppState, _action: PayloadAction<{error?: Error}>) => {},
  },
})

const initSaga = function* () {
  yield* put(actions.setError({error: undefined}))
  const {currentUser} = yield select(({auth}: RootState) => auth)
  if (currentUser) {
    const api = yield* getContext<ReactPTApi>('api')
    yield* call(api.setToken, currentUser.token)
    yield* put(bodyAreaActions.getBodyAreas())
    yield* put(equipmentActions.getEquipment())
    yield* put(actionTypeActions.getActionTypes())
    yield* put(activitiesActions.getActivities())
    yield* put(goalActions.getGoals())
  }
}

const showErrorSaga = function* (action: ReturnType<typeof actions.showError>) {
  const {error} = action.payload
  yield put(actions.setError({error}))
  yield delay(5000)
  yield put(actions.setError({error: undefined}))
}

export const saga = function* () {
  yield takeEvery(actions.init, initSaga)
  yield takeEvery(actions.showError, showErrorSaga)
}
